import { render } from "./SettingsSectionSeparator.vue?vue&type=template&id=d9463348"
import script from "./SettingsSectionSeparator.vue?vue&type=script&lang=js"
export * from "./SettingsSectionSeparator.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__